import { useEffect } from "react";
import "@/App.css";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import PlaceholderPage from "@/pages/PlaceholderPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiesPage from "@/pages/CookiesPage";

// Scrolls to #hash targets after route changes (works from subpages too)
const HashScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // slight delay so the page has rendered
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <HashRouter>
      <HashScroll />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sluzby/zatepleni" element={<PlaceholderPage />} />
        <Route path="/sluzby/rekonstrukce" element={<PlaceholderPage />} />
        <Route path="/sluzby/zednicke-prace" element={<PlaceholderPage />} />
        <Route path="/realizace" element={<PlaceholderPage />} />
        <Route path="/realizace/detail-projektu" element={<PlaceholderPage />} />
        <Route path="/ochrana-osobnich-udaju" element={<PrivacyPolicy />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="*" element={<PlaceholderPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
